import { Link } from "react-router-dom";

const Footer = () => {
  const navLinks = [
    { label: "HOME", href: "/" },
    { label: "INDUSTRIES", href: "/industries" },
    { label: "CASE STUDIES", href: "/case-studies" },
    { label: "CONTACT", href: "/contact" },
  ];

  return (
    <footer className="bg-[#1A1A1A] border-t border-[#FFD100]">
      <div className="w-full px-8 md:px-16 py-12">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          {/* Wordmark */}
          <div className="flex-shrink-0">
            <img
              src="https://public.readdy.ai/ai/img_res/e983ed97-798b-4c5c-b98b-62d7ac7ea8d5.png"
              alt="SOLAINVESTAI"
              className="w-[90px] h-[90px] object-contain mb-3"
            />
            <p
              className="text-[#E5E5E5] text-xs tracking-[2px]"
              style={{ fontFamily: "Arial, sans-serif" }}
            >
              AI-POWERED HEALTH INFRASTRUCTURE
            </p>
          </div>

          {/* Nav */}
          <div className="flex flex-wrap gap-6 md:gap-10">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="text-[#E5E5E5] hover:text-[#FFD100] text-xs tracking-[2px] font-bold transition-colors duration-200 whitespace-nowrap cursor-pointer"
                style={{ fontFamily: "Arial, sans-serif" }}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Contact */}
          <div className="flex flex-col gap-2 text-right">
            <a
              href="mailto:contact@solainvestai.com"
              className="text-[#E5E5E5] text-xs tracking-[1px] hover:text-[#FFD100] transition-colors duration-200"
              style={{ fontFamily: "Arial, sans-serif" }}
            >
              contact@solainvestai.com
            </a>
            <a
              href="tel:+15551234567"
              className="text-[#E5E5E5] text-xs tracking-[1px] hover:text-[#FFD100] transition-colors duration-200"
              style={{ fontFamily: "Arial, sans-serif" }}
            >
              +1 (555) 123-4567
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p
            className="text-[#E5E5E5]/40 text-xs tracking-[1px]"
            style={{ fontFamily: "Arial, sans-serif" }}
          >
            © 2026 SOLAINVESTAI. ALL RIGHTS RESERVED.
          </p>
          <p
            className="text-[#E5E5E5]/40 text-xs tracking-[1px]"
            style={{ fontFamily: "Arial, sans-serif" }}
          >
            PRIVACY POLICY · TERMS OF SERVICE
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
